import React from "react";
import "../../Styles/Modal.css";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

function TermsModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div className="modal-overlay-for-terms">
      <div className="terms-modal-container">
        <div className="client-setup-header-main">
          <div className="client-setup-header-left">
            <IoChevronBackOutline
              className="client-setup-back-icon"
              onClick={() => {
                navigate("/dashboard");
                onClose();
              }}
            />

            <img
              src={require("../../assests/images/nav_bar_logo.png")}
              alt="Wedluk Logo"
              className="client-setup-logo"
            />
          </div>

          <div className="client-setup-header-right">
            <span> Terms & conidtions</span>
          </div>
        </div>

        <div className="terms-content-card">
          <h3>Terms of Service</h3>

          <p className="terms-sub-title">
            This document outlines the policies, obligations, and conditions
            applicable to all users of the WedLuk platform
          </p>

          <ol className="terms-list">
            <li>
              By creating an account, you confirm that all information provided
              by you is accurate, complete, and up to date to the best of your
              knowledge.
            </li>

            <li>
              Users are solely responsible for the content, photographs, and
              personal information shared through their profiles and
              interactions on the platform.
            </li>

            <li>
              WedLuk reserves the right to suspend, restrict, or permanently
              remove accounts found to contain false, misleading, abusive,
              fraudulent, or inappropriate content.
            </li>

            <li>
              Users agree to use the platform only for lawful matrimonial and
              matchmaking purposes and shall not engage in harassment,
              impersonation, spam, or misuse of platform services.
            </li>

            <li>
              WedLuk may provide profile recommendations, matchmaking
              assistance, verification services, and agent-assisted support;
              however, compatibility and marriage outcomes are not guaranteed.
            </li>

            <li>
              Membership plans, platform features, and pricing may be modified,
              updated, restricted, or discontinued at the sole discretion of
              WedLuk without prior notice.
            </li>

            <li>
              Users are responsible for maintaining the confidentiality of
              account credentials and all activities performed under their
              account.
            </li>

            <li>
              WedLuk collects, processes, and stores user information in
              accordance with its Privacy Policy.
            </li>

            <li>
              Matrimony agents and affiliated representatives using the platform
              are expected to comply with applicable laws and professional
              conduct standards.
            </li>

            <li>
              WedLuk shall not be held liable for user interactions, offline
              meetings, disputes, decisions, or outcomes arising from
              connections established through the platform.
            </li>

            <li>
              Users may deactivate or permanently delete profiles through
              available account controls, subject to applicable platform
              policies.
            </li>

            <li>
              By continuing, you acknowledge that you have read, understood, and
              agreed to be bound by these Terms of Service and the WedLuk
              Privacy Policy.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
